<template>
  <a-drawer
    title=""
    :width="480"
    placement="right"
    :visible="visible"
    @close="closeExceptionDrawer">
      
      <div class="row">
        <div class="col-md-12">
          <h3>Add Promo Exceptions</h3>
        </div>
      </div>

    
    <div>
      <label>
        Filter Via: <br> <br>
        <a-select
          v-model="exceptVia"
          style="width: 120px">
          <a-select-option value=1>
            Supplier
          </a-select-option>
          <a-select-option value=2>
            Brand
          </a-select-option>
          <a-select-option value=3>
            Category
          </a-select-option>
        </a-select>
      </label>
      <br><br>

      <div v-if="exceptVia == 1">
        <base-input label="Select Supplier"><br>
            <a-select labelInValue :key="drawerKey" v-model="supplier_ids" showSearch placeholder="Select Supplier" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" :notFoundContent="fetching ? undefined : null" @search="searchSupplier" mode="multiple">
            <a-spin v-if="fetching" slot="notFoundContent" size="small" />
            <a-select-option v-for="option in supplierOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
            </a-select>
        </base-input>
      </div>

      <div v-if="exceptVia == 2">
        <base-input label="Select Brand"><br>
            <a-select labelInValue :key="drawerKey" v-model="brand_ids" showSearch placeholder="Select Brand" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" :notFoundContent="fetching ? undefined : null" @search="searchBrand" mode="multiple">
            <a-spin v-if="fetching" slot="notFoundContent" size="small" />
            <a-select-option v-for="option in brandOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
            </a-select>
        </base-input>
      </div>

      <div v-if="exceptVia == 3">
        <base-input label="Select Category"><br>
            <a-cascader :key="drawerKey" v-model="categoryException" :options="categoriesOptions"
            placeholder="All Categories" style="width: 100%" changeOnSelect/>
        </base-input>
      </div>
      
     
    </div>
  
    <div
      style="
        position: absolute;
        bottom: 0px;
        right: 0px;
        width: -webkit-fill-available;
        background-color: #f2f2f2;
        padding: 10px;
      "
    >
      <button
        class="btn btn-sm btn-primary float-right"
        style="width: 30%"
        @click.prevent="addPromoExceptions"
      >
        Add
      </button>
      <button
        class="btn btn-sm btn-primary float-right"
        style="
          background-color: #394a5d;
          color: white;
          width: 30%;
          margin-right: 5%;
        "
        @click.prevent="closeExceptionDrawer()"
      >
        Cancel
      </button>
    </div>
  </a-drawer>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
import HTTPRequest from '../../../controllers/httpRequest.js';
import secureStorage from '../../../controllers/secureStorage.js';

export default {
  props: {
    promotionId: { type: Number },
    visible: { type: Boolean },
    onClose: { type: Function },
    promoExceptions: { type: Array },
    promoType: { type: String },
    rewardType: { type: String },
    includeItem: { type: String },
    coupleType: { type: String },
    filterOption: {type: Function},
    categoriesOptions: {type: Array},
    brandOptions: {type: Array},
    supplierOptions: {type: Array}
  },
  data() {
    return {
      exceptVia: "1",
      fetching: false,
      supplier_ids: [],
      brand_ids: [],
      categoryException: [],
      // supplierOptions: [],
      // brandOptions: [],
      // categoriesOptions: [],
      drawerKey: 0,
      exceptions_arr: []
    }
  },
  mounted: function() {
    console.log("Print Existing Exceptions")
    console.log(this.promoExceptions) 
  },
  watch: {
    exceptVia: async function(){
      if(this.categoriesOptions.length == 0 && this.exceptVia == 3){
        let options = await HTTPRequest.getRequest(this.endPoint + 'categories/cascader_view', null);
        this.categoriesOptions = options
      }

      this.supplier_ids = []
      this.brand_ids= []
      this.categoryException = []

    }
  },
  computed: {
    ...mapState(['endPoint']),
  },
  methods: {
    async searchSupplier(value){
        this.fetching = true;

        let suppliers = await HTTPRequest.getRequest(this.endPoint + "/suppliers/get_valid_suppliers?name=" + value , null, null)
        if(suppliers != null){
            this.supplierOptions = suppliers
            this.sort(this.supplierOptions);
        } else {
            this.supplierOptions = []
        }

        this.fetching = false;
    },
    async searchBrand(value){
        this.fetching = true;

        // Start
        // [Easyday Plus] Searching for brand name is not working under Promotion Management
        // https://tools.iripple.com/barter-11/bxi-backend/-/issues/1732
        var userBrands = secureStorage.getItem("userBrands") || ""
        let brands = await HTTPRequest.getRequest(this.endPoint + "/brands/get_valid_brands?name=" + value + "&userBrands=" + userBrands , null, null)

        // [Easyday Plus] Searching for brand name is not working under Promotion Management
        // https://tools.iripple.com/barter-11/bxi-backend/-/issues/1732
        // End

        if(brands != null){
            this.brandOptions = brands
            this.sort(this.brandOptions);
        } else {
            this.brandOptions = []
        }

        this.fetching = false;
    },

    sort(data){
      data.sort(function (a, b) {
          return a.name.localeCompare(b.name);
      });
    },

    closeExceptionDrawer(){
      this.exceptVia = "1"
      this.spinning =  false
      this.supplier_ids = []
      this.brand_ids= []
      this.categoryException = []
      this.drawerKey++;
      this.onClose(false)
    },

    checkException(type, value){
      let checker = this.promoExceptions.find(element => (element["exception_type"] === type && element["exception_value"] === value) );
      return checker;
    },

    addPromoExceptions(){
      let exception_value= {}
    
      if(this.exceptVia == "1"){
        for(var i = 0; i < this.supplier_ids.length; i++){
          // console.log(">>> Value Check")
          // console.log(this.supplier_ids[i])
          exception_value= {}
          exception_value["exception_type_display"] = "Supplier"
          exception_value["exception_type"] = "ex_supplierId"
          exception_value["exception_value"] = this.supplier_ids[i]["key"]
          exception_value["exception_value_display"] = null
          if (this.checkException( exception_value["exception_type"], exception_value["exception_value"]) == undefined){
            this.exceptions_arr.push(exception_value)
          }
        }
      }else if (this.exceptVia == "2"){
        for(var i = 0; i < this.brand_ids.length; i++){
          exception_value= {}
          exception_value["exception_type_display"] = "Brand"
          exception_value["exception_type"] = "ex_brandId"
          exception_value["exception_value"] = this.brand_ids[i]["key"]
          exception_value["exception_value_display"] = null
          if (this.checkException( exception_value["exception_type"], exception_value["exception_value"]) == undefined){
            this.exceptions_arr.push(exception_value)
          }
        }
      }else{
        let selected_length = this.categoryException.length
        switch(selected_length) {
          case 2:
            exception_value["exception_type_display"] = "Division"
            exception_value["exception_type"] = "ex_divisionId"
            break;
          case 3:
            exception_value["exception_type_display"] = "Department"
            exception_value["exception_type"] = "ex_departmentId"
            break;
          case 4:
            exception_value["exception_type_display"] = "Section"
            exception_value["exception_type"] = "ex_sectionId"
            break;
          case 5:
            exception_value["exception_type_display"] = "Category"
            exception_value["exception_type"] = "ex_categoryId"
            break;
       }
       exception_value["exception_value"] = this.categoryException[selected_length - 1]
       exception_value["exception_value_display"] = this.categoryException
       if (this.checkException( exception_value["exception_type"], exception_value["exception_value"]) == undefined){
        this.exceptions_arr.push(exception_value)
       }
      }

      this.$emit("updateExceptions", this.exceptions_arr)
      // this.promoExceptions = [...this.promoExceptions, ...this.exceptions_arr]
    }

    
  }

}
</script>

<style scoped>

</style>
